import { render } from "./CoverMark.vue?vue&type=template&id=1d5c98fc&scoped=true"
import script from "./CoverMark.vue?vue&type=script&lang=js"
export * from "./CoverMark.vue?vue&type=script&lang=js"

import "./CoverMark.vue?vue&type=style&index=0&id=1d5c98fc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d5c98fc"]])

export default __exports__